import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import { fetchVisitorStats } from '../../api/analyticsApi';
import countryNameMap from '../../utils/countryNameMap';

const AnalyticsCard = ({ days = 7, propertyId }) => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      const data = await fetchVisitorStats(propertyId, `${days}d`);
      const sorted = Array.isArray(data) ? [...data].sort((a, b) => (b?.count || 0) - (a?.count || 0)) : [];
      setStats(sorted);
      setLoading(false);
    };

    fetchStats();
  }, [days, propertyId]);

  return (
    <Card sx={{ minWidth: 120, minHeight: 465, borderRadius: '9px' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Visitor Activity (Last {days} Days)
        </Typography>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <Box sx={{ maxHeight: 440, overflowY: 'auto', pr: 1 }}>
            {(() => {
              const maxCount = Math.max(...stats.map(s => s.count), 1);
              return stats.map(day => {
                const country = countryNameMap[day._id] || day._id;
                const percentage = (day.count / maxCount) * 100;
                return (
                  <Box key={day._id} mb={1}>
                    <Box display="flex" justifyContent="space-between" mb={0.5} alignItems="center">
                      <Box display="flex" alignItems="center" gap={1}>
                        {typeof day._id === 'string' && day._id.length === 2 && (
                          <img
                            src={`https://flagcdn.com/w20/${day._id.toLowerCase()}.png`}
                            alt={country}
                            style={{ width: 20, height: 14, borderRadius: 2 }}
                          />
                        )}
                        <Typography variant="body2">{country}</Typography>
                      </Box>
                      <Typography variant="body2">{day.count} visits</Typography>
                    </Box>
                    <Box sx={{ backgroundColor: '#e0e0e0', height: 2, borderRadius: 4 }}>
                      <Box
                        sx={{
                          width: `${percentage}%`,
                          backgroundColor: '#1976d2',
                          height: '100%',
                          borderRadius: 4
                        }}
                      />
                    </Box>
                  </Box>
                );
              });
            })()}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default AnalyticsCard;
